export const setValue = (state, { key, value }) => {
  state[key] = value
}
